export type RecurringOrderDeliveryType = "Delivery";

export type RecurringOrderStatus = "Active" | "Cancelled";

export const days = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"] as const;

export type DayOfWeek = (typeof days)[number];

export interface RecurringOrderAddress {
    streetAndHousenumber: string | undefined;
    zipCode: string | undefined;
    city: string | undefined;
    country: string | undefined;
}

export interface RecurringOrderBillingInfo {
    firstName: string | undefined;
    lastName: string | undefined;
    address: RecurringOrderAddress;
}

export interface RecurringOrderCompany {
    id: number;
    name: string | undefined;
    email: string | undefined;
}

export interface RecurringOrder {
    id: string;
    readonly number?: string | undefined;
    createdAt: string;
    updatedAt: string;
    deliveryType: RecurringOrderDeliveryType;
    note: string | undefined;
    member: RecurringOrderMember;
    branch: RecurringOrderBranch;
    slot: RecurringOrderSlot;
    nextOrderDate: string | undefined;
    cancelledAt: string | undefined;
    status: RecurringOrderStatus;
    cancellationReason: string | undefined;
    address: RecurringOrderAddress;
    billingInfo: RecurringOrderBillingInfo;
    fee: number;
    price: number;
    products: RecurringOrderProduct[] | undefined;
    company: RecurringOrderCompany | undefined;
}

export interface RecurringOrderBranch {
    uid: number;
    name: string | undefined;
    address: string | undefined;
    tenantId: string;
    logo: string | undefined;
    readonly phoneNumber?: string | undefined;
}

export interface RecurringOrderMember {
    uid: number;
}

export interface RecurringOrderProduct {
    id: number;
    unitPrice: number;
    count: number;
    name: string | undefined;
    image: string | undefined;
    description: string | undefined;
}

export interface RecurringOrderSlot {
    weekDay: DayOfWeek;
    timeOfDay: string;
}
